import { Icon, IconProps } from "@looksrare/uikit";

const Tail = (props: IconProps) => (
  <Icon viewBox="0 0 9 20" {...props}>
    <path d="M9 0V20H0L8.5 10L0 0H9Z" fill="currentColor" />
  </Icon>
);

export default Tail;
